import { put, takeEvery, takeLatest } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import { messageActions } from 'Ducks';
import { GLOBALS } from 'Constants';
import userTypes from './types';
import userActions from './actions';
import userServices from './services';
import routes from 'Pages/router/constants/routes';

// import { isMobile, isNavigatorUserAgentSupported } from 'Helpers';

function* loginRequest(action) {
	try {
		let response = yield sagaCallService(
			userServices.login,
			action,
			action.payload
		);
		yield put(
			userActions.loginSuccess({
				...response?.data,
				...action?.payload,
			})
		);
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			{ ...action, toastTime: GLOBALS.TOAST_TIMEOUT.UNSET },
			userActions.loginFailure
		);
	}
}

function* otpAnsaafRequest(action) {
	try {
		let response = yield sagaCallService(
			userServices.asnaaf_login,
			action,
			action.payload
		);

		yield put(
			userActions.asnaafOtpSuccess({
				...response?.data,
				...action?.payload,
			})
		);
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			{ ...action, toastTime: GLOBALS.TOAST_TIMEOUT.UNSET },
			userActions.asnaafOtpFailure
		);
	}
}

function* loginAnsaafRequest(action) {
	try {
		let response = yield sagaCallService(
			userServices.login,
			action,
			action.payload
		);
		yield put(
			userActions.asnaafLoginSuccess({
				...response?.data,
				...action?.payload,
			})
		);
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			{ ...action, toastTime: GLOBALS.TOAST_TIMEOUT.UNSET },
			userActions.asnaafLoginFailure
		);
	}
}

function* loginSuccess(action) {
	console.log('loginSuccess', { action });
	const iranFun = [
		13335, 17107, 18591, 31343, 31344, 31345, 31346, 31347, 31349, 31350, 54307,
		54308,
	];
	const others = [9881, 7186];

	const total = [...iranFun, ...others];
	let businessIds = [action.payload?.user?.business_id];

	if (action.payload?.user?.sub_users) {
		businessIds.push(
			...action.payload?.user?.sub_users?.map(
				(item) => item?.attributes?.business?.id
			)
		);
	}

	const isMobile = !!action?.payload?.ua?.mobile;
	if (action.payload.setUser) {
		console.log('action.payload.setUser', action.payload.setUser);
		const needToRedirect = sessionStorage.getItem('redirect');
		const signUp = window.location.href.split('pwa')[1] == '/signup';
		const exep = [
			'/',
			routes.guest,
			routes.gtm,
			routes.signup,
			routes.offlineVendors,
			routes.login,
		];

		// action.payload?.user?.role_name == 'fresh_merchant' &&
		// action.payload?.user?.merchant_name !== "offlineVendor_individual"
		const offlineVendors = localStorage.getItem('asnaaf');
		if (
			!!offlineVendors &&
			offlineVendors?.merchant_name === 'offlineVendor_individual'
		) {
			console.log('offlineVendor_individual', offlineVendor_individual);
			return true;
		}
		if (
			(action.payload?.user?.role_name !== 'merchant' &&
				action.payload?.user?.role_name !== 'fresh_merchant') ||
			businessIds.some((id) => total.includes(id))
		) {
			window.location.href = action.payload?.user?.login_url;
			console.log('redirectVip');
		} else if (window.location.href.includes('offlineVendors')) {
			console.log('offlineVendors');
			return;
		} else if (
			needToRedirect &&
			exep.every((item) => item !== needToRedirect) &&
			!signUp
		) {
			console.log('needToRedirect');
			sessionStorage.removeItem('redirect');
			if (needToRedirect === '/forget-password') {
				sessionStorage.setItem('root_redirect', `/home`);
			} else {
				sessionStorage.setItem('root_redirect', `${needToRedirect}`);
			}
			// window.location.href = `/pwa${needToRedirect}`;
		} else if (action.payload?.user?.sign_in_count > 1) {
			console.log('dashboard');
			sessionStorage.setItem('root_redirect', `/home`);
			// window.location.href = /pwa/home`;
		} else {
			console.log('fillBusinessForm');
			sessionStorage.setItem('root_redirect', `/home`);
			// window.location.href = `/pwa/home`;
			// window.location.href = `/pwa/signupbusiness`;
		}
	}
}

function* forgetPasswordRequest(action) {
	try {
		let response = yield sagaCallService(
			userServices.forget_password,
			action,
			action.payload
		);
		yield put(userActions.forgetPasswordSuccess(response.data));
		yield put(
			messageActions.pushSuccessToast({
				title: response?.data?.msg,
				toastTime: GLOBALS.TOAST_TIMEOUT.UNSET,
			})
		);
	} catch (error) {
		yield sagaErrorDispatcher(
			error,
			{ ...action, toastTime: GLOBALS.TOAST_TIMEOUT.UNSET },
			userActions.forgetPasswordFailure
		);
	}
}

function* resetPasswordRequest(action) {
	try {
		let response = yield sagaCallService(
			userServices.reset_password,
			action,
			action.payload
		);
		yield put(userActions.resetPasswordSuccess(response.data));
		yield put(
			messageActions.pushSuccessToast({
				title: response?.data?.msg,
				toastTime: GLOBALS.TOAST_TIMEOUT.UNSET,
			})
		);
	} catch (error) {
		yield sagaErrorDispatcher(
			error,
			{ ...action, toastTime: GLOBALS.TOAST_TIMEOUT.UNSET },
			userActions.resetPasswordFailure
		);
	}
}

function* userRegisterRequest(action) {
	try {
		let response = yield sagaCallService(
			userServices.register,
			action,
			action.payload
		);
		yield put(
			userActions.registerFreshSuccess({ ...response.data, ...action?.payload })
		);
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			{ ...action, toastTime: GLOBALS.TOAST_TIMEOUT.UNSET },
			userActions.loginFailure
		);
	}
}

function* freshUserRegisterRequest(action) {
	try {
		let response = yield sagaCallService(
			userServices.fresh_register,
			action,
			action.payload
		);
		yield put(
			userActions.registerFreshSuccess({ ...response.data, ...action?.payload })
		);
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			{ ...action, toastTime: GLOBALS.TOAST_TIMEOUT.UNSET },
			userActions.registerFreshFailure
		);
	}
}

function* userCreateOTPRequest(action) {
	try {
		let response = yield sagaCallService(
			userServices.createOTP,
			action,
			action.payload
		);

		yield put(
			userActions.createOTPSuccess({ ...response.data, ...action?.payload })
		);
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			{ ...action, toastTime: GLOBALS.TOAST_TIMEOUT.UNSET },
			userActions.createOTPFailure
		);
	}
}

function* getProfleRequest(action) {
	try {
		let response = yield sagaCallService(
			() => userServices.profile(action.payload),
			action
		);
		yield put(userActions.profileSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, userActions.profileFailure);
	}
}

function* getProfleCompleteRequest(action) {
	try {
		let response = yield sagaCallService(
			() => userServices.profileCompelete(action.payload),
			action
		);
		if (response?.data) {
			yield put(userActions.profileGetSuccess(response?.data));
		}
	} catch (e) {
		yield sagaErrorDispatcher(e, action, userActions.profileGetFailure);
	}
}

function* updateProfleRequest(action) {
	try {
		let response = yield sagaCallService(
			() => userServices.updateProfile(action.payload),
			action
		);
		yield put(userActions.profileUpdateSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			userActions.profileUpdateFailure,
			true
		);
	}
}
function* updateProfleOTPRequest(action) {
	try {
		let response = yield sagaCallService(
			() => userServices.changeNumberOTP(action.payload),
			action
		);
		yield put(userActions.profileUpdateOTPSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, userActions.profileUpdateOTPFailure);
	}
}

function* updateProfleOTPConfirmRequest(action) {
	try {
		let response = yield sagaCallService(
			() => userServices.changeNumberOTPConfirm(action.payload),
			action
		);
		yield put(userActions.profileUpdateOTPConfirmSuccesst(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			userActions.profileUpdateOTPConfirmFailure
		);
	}
}

function* userWizard(action) {
	try {
		let response = yield sagaCallService(
			userServices.userWizard,
			action,
			action.payload
		);
		yield put(userActions.profileWizardSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, userActions.profileWizardFailure);
	}
}

function* updateProfileRequest(action) {
	try {
		yield put(userActions.updateUserInfoSuccess(action?.payload));
	} catch (e) {
		console.log('GOT ERROR in updateProfileRequest');
		// yield sagaErrorDispatcher(e, action, userActions.profileWizardFailure);
	}
}

const userSagas = [
	takeLatest(userTypes.LOGIN.REUQEST, loginRequest),
	takeLatest(userTypes.LOGIN.SUCCESS, loginSuccess),
	takeLatest(userTypes.REGISTER_FRESH.REQUEST, freshUserRegisterRequest),
	takeLatest(userTypes.REGISTER_FRESH.SUCCESS, loginSuccess),
	takeLatest(userTypes.CREATE_OTP.SUCCESS, loginSuccess),
	takeLatest(userTypes.FORGET_PASSWORD.REQUEST, forgetPasswordRequest),
	takeLatest(userTypes.RESET_PASSWORD.REQUEST, resetPasswordRequest),
	takeLatest(userTypes.REGISTER.REQUEST, userRegisterRequest),
	takeLatest(userTypes.CREATE_OTP.REQUEST, userCreateOTPRequest),
	takeEvery(userTypes.PROFILE.REQUEST, getProfleRequest),
	takeLatest(userTypes.PROFILE_UPDATE.REQUEST, updateProfleRequest),
	takeLatest(userTypes.CHANGE_NUMBER_OTP.REQUEST, updateProfleOTPRequest),
	takeLatest(userTypes.WIZARD.REQUEST, userWizard),
	takeLatest(userTypes.ASNAAF_LOGIN.REQUEST, loginAnsaafRequest),
	takeLatest(userTypes.GET_PROFILE.REQUEST, getProfleCompleteRequest),
	takeLatest(
		userTypes.CHANGE_NUMBER_OTP_CONFIRM.REQUEST,
		updateProfleOTPConfirmRequest
	),
	takeLatest(userTypes.ASNAAF_OTP.REQUEST, otpAnsaafRequest),
	takeLatest(userTypes.UPDATE_PROFILE.REQUEST, updateProfileRequest),
];

export default userSagas;
